const englishTabs = {
    dashboard: "Dashboard",
    dailyEntry: "DailyEntry",
    accounts: "Accounts",
    cashControl: "Cash Control",
    hrPayroll: "HrPayroll",
    purchases: "Purchases",
    sales: "Sales",
    expenses: "Expenses",
    stock: "Stock",
    inventory: "Inventory",
    reports: "Reports",
    tools: "Tools",
    settings: "Settings",
    retail: "Retail",
};


const arabicTabs = {
    dashboard: "لوحة التحكم",
    dailyEntry: "القيود اليومية",
    accounts: "الحسابات",
    cashControl: "إدارة النقد",
    hrPayroll: "الموارد البشرية",
    purchases: "المشتريات",
    sales: "المبيعات",
    expenses: "المصروفات",
    stock: "المخزون",
    inventory: "الجرد",
    reports: "التقارير",
    tools: "الأدوات",
    settings: "الإعدادات",
    retail: "التجزئة",
};

const frenchTabs = {
    dashboard: "Tableau de bord",
    dailyEntry: "Écritures journalières",
    accounts: "Comptes",
    cashControl: "Contrôle de caisse",
    hrPayroll: "RH & Paie",
    purchases: "Achats",
    sales: "Ventes",
    expenses: "Dépenses",
    stock: "Stock",
    inventory: "Inventaire",
    reports: "Rapports",
    tools: "Outils",
    settings: "Paramètres",
    retail: "Vente au détail",
};

const spanishTabs = {
    dashboard: "Tablero",
    dailyEntry: "Asientos diarios",
    accounts: "Cuentas",
    cashControl: "Control de caja",
    hrPayroll: "RRHH y Nómina",
    purchases: "Compras",
    sales: "Ventas",
    expenses: "Gastos",
    stock: "Stock",
    inventory: "Inventario",
    reports: "Informes",
    tools: "Herramientas",
    settings: "Configuraciones",
    retail: "Venta al por menor",
};

const portugueseTabs = {
    dashboard: "Painel",
    dailyEntry: "Lançamentos diários",
    accounts: "Contas",
    cashControl: "Controle de caixa",
    hrPayroll: "RH e Folha",
    purchases: "Compras",
    sales: "Vendas",
    expenses: "Despesas",
    stock: "Estoque",
    inventory: "Inventário",
    reports: "Relatórios",
    tools: "Ferramentas",
    settings: "Configurações",
    retail: "Varejo",
};

const brazilianPortugueseTabs = {
    dashboard: "Painel de Controle",
    dailyEntry: "Lançamentos Diários",
    accounts: "Contas",
    cashControl: "Controle de Caixa",
    hrPayroll: "RH e Folha de Pagamento",
    purchases: "Compras",
    sales: "Vendas",
    expenses: "Despesas",
    stock: "Estoque",
    inventory: "Inventário",
    reports: "Relatórios",
    tools: "Ferramentas",
    settings: "Configurações",
    retail: "Varejo",
};




const englishPages = {
    salesDashboard: "salesDashboard",
    chartOfAccount: "ChartOfAccount",
    myAccounts: "MyAccounts",
    groups: "Groups",
    delivery: "Delivery",

    cashAccount: "Cash Account",
    varianceAccount: "Variance Account",
    cashTransfer: "Cash Transfer",
    payments: "Payments",
    receipts: "Receipts",

    employee: "Employee",
    salary: "Salary",

    supplier: "Supplier",
    purchaseInvoice: "Purchase Invoice",
    purchaseReturn: "Purchase Return",
    purchaseOrder: "Purchase Order",

    customer: "Customer",
    salesInvoice: "Sales Invoice",
    salesReturn: "Sales Return",
    salesOrder: "Sales Order",

    expenseAccount: "Expense Account",
    expenseSupplier: "Expense Supplier",
    expenseInvoice: "Expense Invoice",

    stockControl: "Stock Control",
    stockTransfer: "Stock Transfer",
    stockCount: "Stock Count",

    products: "Products",
    categories: "Categories",
    brands: "Brands",
    seasons: "Seasons",
    vatGroup: "VatGroup",

    financial: "Financial",
    operational: "Operational",
    stockReport: "Stock Report",
    sessions: "Sessions",
    validation: "Validations",

    //tools
    stockTools: "Stock Tools",
    openingYear: "Opening Year",
    posTools: "PosTools",
    import: "Import",
    backup: "Backup",

    //settings
    general: "General",
    user: "User",
    role: "Role",
    linkAccount: "Link Account",
    currency: "Currency",

    //retail
    pos: "POS",
    dineIn: "Dine In",

};


const arabicPages = {
    salesDashboard: "جدول المبيعات",
    chartOfAccount: "دليل الحسابات",

    myAccounts: "حساباتي",
    groups: "المجموعات",
    delivery: "التوصيل",

    cashAccount: "حساب النقدية",
    varianceAccount: "حساب الفروقات",
    cashTransfer: "تحويل نقدي",
    payments: "المدفوعات",
    receipts: "الإيصال",

    employee: "الموظف",
    salary: "الراتب",

    supplier: "المورد",
    purchaseInvoice: "فاتورة الشراء",
    purchaseReturn: "إرجاع الشراء",
    purchaseOrder: "طلب الشراء",

    customer: "العميل",
    salesInvoice: "فاتورة المبيعات",
    salesReturn: "إرجاع المبيعات",
    salesOrder: "طلب المبيعات",

    expenseAccount: "حساب المصروفات",
    expenseSupplier: "مورد المصروفات",
    expenseInvoice: "فاتورة المصروفات",

    stockControl: "مراقبة المخزون",
    stockTransfer: "تحويل المخزون",
    stockCount: "تعداد المخزون",

    products: "المنتجات",
    categories: "الفئات",
    brands: "العلامات التجارية",
    seasons: "المواسم",
    vatGroup: "مجموعة الضريبة",

    financial: "المالية",
    operational: "التشغيلية",
    stockReport: "تقرير المخزون",
    sessions: "الجلسات",
    validation: "تقرير التحقق",

    //tools
    stockTools: "أدوات المخزون",
    openingYear: "السنة الافتتاحية",
    posTools: "أدوات نقطة البيع",
    import: "استيراد",
    backup: "النسخ الاحتياطي",

    //settings
    general: "الإعدادات العامة",
    user: "المستخدم",
    role: "الدور",
    linkAccount: "ربط الحساب",
    currency: "العملة",

    //retail
    pos: "نقطة البيع",
    dineIn: "داخل المطعم",
};

const frenchPages = {
    salesDashboard: "Tableau des ventes",
    chartOfAccount: "Plan comptable",
    myAccounts: "Mes comptes",
    groups: "Groupes",
    delivery: "Livraison",

    cashAccount: "Compte de caisse",
    varianceAccount: "Compte d'écart",
    cashTransfer: "Transfert de fonds",
    payments: "Paiements",
    receipts: "Reçus",

    employee: "Employé",
    salary: "Salaire",

    supplier: "Fournisseur",
    purchaseInvoice: "Facture d'achat",
    purchaseReturn: "Retour d'achat",
    purchaseOrder: "Commande d'achat",

    customer: "Client",
    salesInvoice: "Facture de vente",
    salesReturn: "Retour de vente",
    salesOrder: "Commande de vente",

    expenseAccount: "Compte de dépenses",
    expenseSupplier: "Fournisseur de dépenses",
    expenseInvoice: "Facture de dépenses",

    stockControl: "Contrôle de stock",
    stockTransfer: "Transfert de stock",
    stockCount: "Inventaire",

    products: "Produits",
    categories: "Catégories",
    brands: "Marques",
    seasons: "Saisons",
    vatGroup: "Groupe TVA",

    financial: "Financier",
    operational: "Opérationnel",
    stockReport: "Rapport de stock",
    sessions: "Sessions",
    validation: "Validations",

    stockTools: "Outils de stock",
    openingYear: "Année d'ouverture",
    posTools: "Outils POS",
    import: "Importer",
    backup: "Sauvegarde",

    general: "Général",
    user: "Utilisateur",
    role: "Rôle",
    linkAccount: "Lier un compte",
    currency: "Devise",

    pos: "Point de vente",
    dineIn: "Sur place",
};

const spanishPages = {
    salesDashboard: "Panel de ventas",
    chartOfAccount: "Plan de cuentas",
    myAccounts: "Mis cuentas",
    groups: "Grupos",
    delivery: "Entrega",

    cashAccount: "Cuenta de efectivo",
    varianceAccount: "Cuenta de variación",
    cashTransfer: "Transferencia de efectivo",
    payments: "Pagos",
    receipts: "Recibos",

    employee: "Empleado",
    salary: "Salario",

    supplier: "Proveedor",
    purchaseInvoice: "Factura de compra",
    purchaseReturn: "Devolución de compra",
    purchaseOrder: "Orden de compra",

    customer: "Cliente",
    salesInvoice: "Factura de venta",
    salesReturn: "Devolución de venta",
    salesOrder: "Orden de venta",

    expenseAccount: "Cuenta de gastos",
    expenseSupplier: "Proveedor de gastos",
    expenseInvoice: "Factura de gastos",

    stockControl: "Control de inventario",
    stockTransfer: "Transferencia de stock",
    stockCount: "Conteo de stock",

    products: "Productos",
    categories: "Categorías",
    brands: "Marcas",
    seasons: "Temporadas",
    vatGroup: "Grupo IVA",

    financial: "Financiero",
    operational: "Operativo",
    stockReport: "Informe de inventario",
    sessions: "Sesiones",
    validation: "Validaciones",

    stockTools: "Herramientas de inventario",
    openingYear: "Apertura del año",
    posTools: "Herramientas POS",
    import: "Importar",
    backup: "Copia de seguridad",

    general: "General",
    user: "Usuario",
    role: "Rol",
    linkAccount: "Vincular cuenta",
    currency: "Moneda",

    pos: "Punto de venta",
    dineIn: "Comer en el local",
};

const portuguesePages = {
    salesDashboard: "Painel de vendas",
    chartOfAccount: "Plano de contas",
    myAccounts: "Minhas contas",
    groups: "Grupos",
    delivery: "Entrega",

    cashAccount: "Conta de caixa",
    varianceAccount: "Conta de variação",
    cashTransfer: "Transferência de caixa",
    payments: "Pagamentos",
    receipts: "Recibos",

    employee: "Funcionário",
    salary: "Salário",

    supplier: "Fornecedor",
    purchaseInvoice: "Fatura de compra",
    purchaseReturn: "Devolução de compra",
    purchaseOrder: "Pedido de compra",

    customer: "Cliente",
    salesInvoice: "Fatura de venda",
    salesReturn: "Devolução de venda",
    salesOrder: "Pedido de venda",

    expenseAccount: "Conta de despesas",
    expenseSupplier: "Fornecedor de despesas",
    expenseInvoice: "Fatura de despesas",

    stockControl: "Controle de estoque",
    stockTransfer: "Transferência de estoque",
    stockCount: "Contagem de estoque",

    products: "Produtos",
    categories: "Categorias",
    brands: "Marcas",
    seasons: "Temporadas",
    vatGroup: "Grupo de IVA",

    financial: "Financeiro",
    operational: "Operacional",
    stockReport: "Relatório de estoque",
    sessions: "Sessões",
    validation: "Validações",

    stockTools: "Ferramentas de estoque",
    openingYear: "Ano de abertura",
    posTools: "Ferramentas POS",
    import: "Importar",
    backup: "Backup",

    general: "Geral",
    user: "Usuário",
    role: "Função",
    linkAccount: "Vincular conta",
    currency: "Moeda",

    pos: "Ponto de venda",
    dineIn: "Comer no local",
};

const brazilianPortuguesePages = {
    salesDashboard: "Painel de Vendas",
    chartOfAccount: "Plano de Contas",
    myAccounts: "Minhas Contas",
    groups: "Grupos",
    delivery: "Entrega",

    cashAccount: "Conta de Caixa",
    varianceAccount: "Conta de Diferença",
    cashTransfer: "Transferência de Caixa",
    payments: "Pagamentos",
    receipts: "Recebimentos",

    employee: "Funcionário",
    salary: "Folha de Pagamento",

    supplier: "Fornecedor",
    purchaseInvoice: "Nota Fiscal de Compra",
    purchaseReturn: "Devolução de Compra",
    purchaseOrder: "Pedido de Compra",

    customer: "Cliente",
    salesInvoice: "Nota Fiscal de Venda",
    salesReturn: "Devolução de Venda",
    salesOrder: "Pedido de Venda",

    expenseAccount: "Conta de Despesa",
    expenseSupplier: "Fornecedor de Despesa",
    expenseInvoice: "Nota Fiscal de Despesa",

    stockControl: "Controle de Estoque",
    stockTransfer: "Transferência de Estoque",
    stockCount: "Contagem de Estoque",

    products: "Produtos",
    categories: "Categorias",
    brands: "Marcas",
    seasons: "Temporadas",
    vatGroup: "Grupo de Impostos",

    financial: "Financeiro",
    operational: "Operacional",
    stockReport: "Relatório de Estoque",
    sessions: "Sessões",
    validation: "Validações",

    // Ferramentas
    stockTools: "Ferramentas de Estoque",
    openingYear: "Ano de Abertura",
    posTools: "Ferramentas do PDV",
    import: "Importar",
    backup: "Backup",

    // Configurações
    general: "Geral",
    user: "Usuário",
    role: "Função",
    linkAccount: "Vincular Conta",
    currency: "Moeda",

    // PDV
    pos: "PDV",
    dineIn: "Comer no local",
};

const englishForms = {
    // Common
    ID: "ID",
    Ref: "Ref",
    CreatedAt: "Created At",
    Date: "Date",
    Purchase: "Purchase",
    Account: "Account",
    Type: "Type",  
    
    LBP: "LBP",
    USD: "USD",
    Variance: "Variance",
    delivery: "delivery",
    Payment: "Payment",
    Status: "Status",
    Details: "Details",
    Actions: "Actions",
    stockCount: "Stock Count",
    NoData: "No data",
    Select: "Select...",
    SelectAccount: "Select Account:",
    Name: "Name",
    Phone: "Phone",
    Address: "Address",
    isActive: "isActive",
    isAuxiliary: "isAuxiliary",
    Add: "Add",
    Save: "Save",
    Branch: "Branch",
    Project: "Project",
    Reference: "Reference",
    Optional: "Optional",
    currency: "Currency",
    Warehouse: "Warehouse",
    Products: "Products",
    Unit: "Unit",
    Quantity: "Quantity",
    FreeQty: "Free Qty",
    Cost: "Cost",
    Price: "Price",
    Discount: "Discount",
    Total: "Total",
    VAT: "VAT",
    Expense: "Expense",
    NetTotal: "Net Total",
    Close: "Close",
    Percentage: "Percentage",
    Currency: "Currency",
    Rate: "Rate",
    onAccount: "onAccount",
    Amount: "Amount",
    PaymentType: "PaymentType",
    Cash: "Cash",
    DownPayment: "DownPayment",
    Description: "Description",
    Active: "Active",
    Stockable: "Stockable",
    LowInStock: "Low In Stock",
    Upload: "Upload",
    Barcode: "Barcode",
   
    Width: "Width",
    Length: "Length",
    Height: "Height",
    Diameter: "Diameter",
    Size: "Size",
    ExpiryDate: "Expiry Date",
    mmddyyyy: "mm/dd/yyyy",
    scanBarcode: "scan barcode to add ..",
    Group: "Group",
    Registration: "Registration",
    Debit: "Debit",
    Credit: "Credit",
    DebitLBP: "Debit LBP",
    CreditLBP: "Credit LBP",
    DebitUSD: "Debit USD",
    CreditUSD: "Credit USD",
    Charges: "Charges",
    AllocateCharges: "Allocate Charges",
    CartDiscounts: "Cart Discounts",
    SubTotal: "SUB Total",
    InvoiceDiscount: "InvoiceDiscount",
    DiscountType: "DiscountType",
    General: "General",
    Prices: "Prices",
    Units: "Units",
    Brand: "Brand",
    Season: "Season",
    RaiseBy: "RaiseBy",
    BoxColor: "Box Color",
    ServiceProduct: "Service Product",
    SimpleProduct: "Simple Product",
    SimpleService: "Simple Service",
    // Specific forms
    JournalVoucher: "Journal Voucher",
    AccountRegistration: "Account Registration",
    Delivery: "Delivery",
    CashTransfer: "Cash Transfer",
    ApplyPaymentToInvoice: "Apply Payment to Invoice",   
    Employee: "Employee",
    Salary: "Salary",
    Supplier: "Supplier",  
    PurchaseInvoice: "Purchase Invoice",
    PurchaseReturn: "Purchase Return",
    PurchaseOrder: "Purchase Order",
    Customer: "Customer",
    SalesInvoice: "Sales Invoice",
    In: "In",
    Out: "Out",
    SalesReturn: "Sales Return",
    SalesOrder: "Sales Order",
    UnitCost: "Unit Cost",
    ExpenseAccount: "Expense Account",
    ExpenseSupplier: "Expense Supplier",
    ExpenseInvoice: "Expense Invoice",
    StockControl: "Stock Control",
    StockTransfer: "Stock Transfer",
    StockCount: "Stock Count",
    Opening: "Opening",
    Category: "Category",
    VATGroup: "VAT Group",
    Pcs: "Pcs",
    FromWarehouse: "From Warehouse",
    ToWarehouse: "To Warehouse",
    NetQuantity: "net Quantity",
    Variation: "Variation",
    FromCash: "From Cash",
    ToCash: "To Cash",
    SelectProducts: "Select Products",
    InvoiceReceipts: "Invoice Receipts" ,
    CartLockedMessage: "Note: Cart is locked, remove allocation of charges to unlock",
    SchedulePayments: "Schedule Payments",
    Weekly: "Weekly",
    Monthly: "Monthly",
    Yearly: "Yearly",
    View: "View",
    In: "In"
};

const arabicForms = {
    // Common
    ID: "المعرف",
    Ref: "المرجع",
    CreatedAt: "تم الإنشاء في",
    Serial: "تسلسل",
    Close: "إغلاق",
    Expense: "مصروف",
    CartLockedMessage: "ملاحظة: السلة مقفولة، قم بإلغاء توزيع الرسوم لفتحها",
    InvoiceReceipts: "إيصالات الفواتير" ,
    UnitCost: "تكلفة الوحدة",
    Date: "التاريخ",
    delivery: "التوصيل",
    SelectAccount: "اختر الحساب:" ,
    In: "داخل",      
    Out: "خارج",    
    Account: "الحساب",
    Purchase: "شراء",
    Variance: "التباين" ,
    currency: "العملة",
    Type: "النوع",
    LBP: "ل.ل",
    USD: "دولار",
    onAccount: "على الحساب",
    StockCount: "جرد المخزون" ,
    Payment: "الدفع",
   
    Status: "الحالة",
    Details: "التفاصيل",
    Actions: "الإجراءات",
    Weekly: "أسبوعي",        
    Monthly: "شهري",       
    Yearly: "سنوي",    
    NoData: "لا توجد بيانات",
    Select: "اختر...",
    Name: "الاسم",
    FromCash: "من النقدية",
    ToCash: "إلى النقدية",
    Phone: "الهاتف",
    Address: "العنوان",
    isActive: "نشط",
    isAuxiliary: "مساعد",
    Add: "إضافة",
    Save: "حفظ",
    Branch: "الفرع",
    Project: "المشروع",
    Reference: "المرجع",
    Optional: "اختياري",
    Warehouse: "المستودع",
    Products: "المنتجات",
    Unit: "الوحدة",
    Quantity: "الكمية",
    FreeQty: "كمية مجانية",
    Cost: "التكلفة",
    Price: "السعر",
    Discount: "الخصم",
    Total: "المجموع",  
    VAT: "ضريبة القيمة المضافة",
    NetTotal: "الصافي",
    Percentage: "النسبة المئوية",
    Currency: "العملة",
    Rate: "السعر",
    Amount: "المبلغ",
    PaymentType: "نوع الدفع",
    Cash: "نقدي",
    DownPayment: "دفعة مقدمة",
    Description: "الوصف",
    Active: "نشط",
    Stockable: "قابل للتخزين",
    LowInStock: "منخفض في المخزون",
    Upload: "رفع",
    Barcode: "الباركود",
    Width: "العرض",
    Length: "الطول",
    Height: "الارتفاع",
    Diameter: "القطر",
    Size: "الحجم",
    ExpiryDate: "تاريخ الانتهاء",
    
    mmddyyyy: "شهر/يوم/سنة",
    scanBarcode: "امسح الباركود للإضافة ..",
    Group: "المجموعة",
    Registration: "رقم التسجيل",
    Debit: "مدين",
    Credit: "دائن",
    DebitLBP: "مدين ل.ل",
    CreditLBP: "دائن ل.ل",
    DebitUSD: "مدين دولار",
    CreditUSD: "دائن دولار",
    Charges: "الرسوم",
    AllocateCharges: "توزيع الرسوم",
    CartDiscounts: "خصومات السلة",
    SubTotal: "المجموع الفرعي",
    InvoiceDiscount: "خصم الفاتورة",
    DiscountType: "نوع الخصم",
    General: "عام",
    Prices: "الأسعار",
    Units: "الوحدات",
    Brand: "العلامة التجارية",
    Season: "الموسم",
    RaiseBy: "زيادة بمقدار",
    BoxColor: "لون الصندوق",
    ServiceProduct: "منتج خدمي",
    SimpleProduct: "منتج بسيط",
    SimpleService: "خدمة بسيطة",
    // Specific forms
    JournalVoucher: "سند القيد",
    AccountRegistration: "تسجيل الحساب",
    Delivery: "التوصيل",
    CashTransfer: "تحويل نقدي",
    ApplyPaymentToInvoice: "تطبيق الدفع على الفاتورة",
    Employee: "الموظف",
    Salary: "الراتب",
    Supplier: "المورد",
    PurchaseInvoice: "فاتورة شراء",
    PurchaseReturn: "مرتجع شراء",
    PurchaseOrder: "أمر شراء",
    Customer: "العميل",
    SalesInvoice: "فاتورة مبيعات",
    SalesReturn: "مرتجع مبيعات",
    SalesOrder: "أمر مبيعات",
    ExpenseAccount: "حساب المصروفات",
    ExpenseSupplier: "مورد المصروفات",
    ExpenseInvoice: "فاتورة مصروفات",
    StockControl: "مراقبة المخزون",
    StockTransfer: "نقل المخزون",
    StockCount: "جرد المخزون",
    Opening: "الافتتاح",
    Category: "الفئة",
    VATGroup: "مجموعة الضريبة",
    Pcs: "قطعة",
    FromWarehouse: "من المستودع",
    ToWarehouse: "إلى المستودع",
    NetQuantity: "الكمية الصافية",
    SelectProducts: "اختر المنتجات" ,
    Variation: "التباين",
    SchedulePayments: "جدولة المدفوعات:",
    View: "عرض",
    In: "داخل"
};

const frenchForms = {
    // Common
    ID: "ID",
    Ref: "Réf",
    Serial: "Série",
    CreatedAt: "Créé à",
    Date: "Date",
    Account: "Compte",
    InvoiceReceipts: "Reçus de facture",
    Close: "Fermer",
    SelectAccount: "Sélectionnez le compte:",
    Variance: "Écart",  
    Type: "Type",
    StockCount: "Inventaire",
    LBP: "LBP",
    USD: "USD",
    In: "Entrée",    
    Out: "Sortie",   
    currency: "Devise",
    UnitCost: "Coût unitaire",
    Weekly: "Hebdomadaire",  // Formal
    Monthly: "Mensuel",
    Yearly: "Annuel",
    Purchase: "Achat",
    Expense: "Dépense",
    delivery: "Livraison",
    onAccount: "surCompte",
    Payment: "Paiement",
    FromCash: "De la caisse",
    ToCash: "À la caisse",
    Status: "Statut",
    CartLockedMessage: "Note : Panier verrouillé, supprimez la répartition des frais pour déverrouiller",
    Details: "Détails",
    Actions: "Actions",
    NoData: "Aucune donnée",
    Select: "Sélectionner...",
    Name: "Nom",
    Phone: "Téléphone",
    Address: "Adresse",
    isActive: "estActif",
    isAuxiliary: "estAuxiliaire",
    Add: "Ajouter",
    Save: "Enregistrer",
    Branch: "Branche",
    Project: "Projet",
    Reference: "Référence",
    Optional: "Optionnel",
    Warehouse: "Entrepôt",
    Products: "Produits",
    Unit: "Unité",
    Quantity: "Quantité",
    FreeQty: "Qté gratuite",
    Cost: "Coût",
    Price: "Prix",
    Discount: "Remise",
    Total: "Total",
    VAT: "TVA",
    NetTotal: "Net Total",
    Percentage: "Pourcentage",
    Currency: "Devise",
    Rate: "Taux",
    Amount: "Montant",
    PaymentType: "TypePaiement",
    Cash: "Espèces",
    DownPayment: "Acompte",
    Description: "Description",
    Active: "Actif",
    Stockable: "Stockable",
    LowInStock: "Faible en stock",
    Upload: "Télécharger",
    Barcode: "Code-barres",
    Width: "Largeur",
    Length: "Longueur",
    Height: "Hauteur",
    Diameter: "Diamètre",
    Size: "Taille",
    ExpiryDate: "Date d'expiration",
    mmddyyyy: "mm/jj/aaaa",
    scanBarcode: "scannez le code-barres pour ajouter ..",
    Group: "Groupe",
    Registration: "N° d'enregistrement",
    Debit: "Débit",
    Credit: "Crédit",
    DebitLBP: "Débit LBP",
    CreditLBP: "Crédit LBP",
    DebitUSD: "Débit USD",
    CreditUSD: "Crédit USD",
    Charges: "Frais",
    AllocateCharges: "Allouer les frais",
    CartDiscounts: "Remises panier",
    SubTotal: "SOUS-Total",
    InvoiceDiscount: "RemiseFacture",
    DiscountType: "TypeRemise",
    General: "Général",
    Prices: "Prix",
    Units: "Unités",
    Brand: "Marque",
    Season: "Saison",
    RaiseBy: "AugmenterPar",
    BoxColor: "CouleurBoîte",
    ServiceProduct: "ProduitService",
    SimpleProduct: "ProduitSimple",
    SimpleService: "ServiceSimple",
    // Specific forms
    JournalVoucher: "Bordereau de journal",
    AccountRegistration: "Enregistrement de compte",
    Delivery: "Livraison",
    CashTransfer: "Transfert d'espèces",
    ApplyPaymentToInvoice: "Appliquer le paiement à la facture",
    Employee: "Employé",
   
    Salary: "Salaire",
    Supplier: "Fournisseur",
    PurchaseInvoice: "Facture d'achat",
    PurchaseReturn: "Retour d'achat",
    PurchaseOrder: "Bon de commande",
    Customer: "Client",
    SalesInvoice: "Facture de vente",
    SalesReturn: "Retour de vente",
    SalesOrder: "Bon de commande",
    ExpenseAccount: "Compte de dépenses",
    ExpenseSupplier: "Fournisseur de dépenses",
    ExpenseInvoice: "Facture de dépenses",
    StockControl: "Contrôle des stocks",
    StockTransfer: "Transfert de stock",
    StockCount: "Comptage de stock",
    Opening: "Ouverture",
    Category: "Catégorie",
    VATGroup: "GroupeTVA",
    Pcs: "Pcs",
    FromWarehouse: "De l'entrepôt",
    ToWarehouse: "Vers l'entrepôt",
    NetQuantity: "Qté nette",
    SelectProducts: "Sélectionner les produits", 
    Variation: "Variation",
    SchedulePayments: "Planifier les paiements",
    View: "Voir",
    In: "Dans"
};

const spanishForms = {
    // Common
    ID: "ID",
    Ref: "Ref",
    CreatedAt: "Creado en",
    Date: "Fecha",
    Serial: "Serie",
    Account: "Cuenta",
    Close: "Cerrar",
    Variance: "Variación",
    StockCount: "Conteo de inventario",
    Purchase: "Compra",
    delivery: "Entrega",
    UnitCost: "Costo unitario",
    InvoiceReceipts: "Recibos de factura",
    onAccount: "enCuenta",
    SelectAccount: "Seleccione cuenta:",
    In: "Entrada",
    Out: "Salida",
     currency: "Moneda",
    Expense: "Gasto",
    Type: "Tipo",
    LBP: "LBP",
    USD: "USD",
    Payment: "Pago",
    FromCash: "De efectivo",
    Weekly: "Semanal",
    Monthly: "Mensual",
    Yearly: "Anual",
    CartLockedMessage: "Nota: Carrito bloqueado, elimine la asignación de cargos para desbloquear",
    ToCash: "A efectivo",
    Status: "Estado",
    Details: "Detalles",
    Actions: "Acciones",
    NoData: "Sin datos",
    Select: "Seleccionar...",
    Name: "Nombre",
    Phone: "Teléfono",
    Address: "Dirección",
    isActive: "estáActivo",
    isAuxiliary: "esAuxiliar",
    Add: "Agregar",
    Save: "Guardar",
    Branch: "Sucursal",
    Project: "Proyecto",
    Reference: "Referencia",
    Optional: "Opcional",
    Warehouse: "Almacén",
    Products: "Productos",
    Unit: "Unidad",
    Quantity: "Cantidad",
    FreeQty: "Ctdad gratis",
    Cost: "Costo",
    Price: "Precio",
    Discount: "Descuento",
    Total: "Total",
    VAT: "IVA",
    NetTotal: "Total Neto",
    Percentage: "Porcentaje",
    Currency: "Moneda",
    Rate: "Tasa",
    Amount: "Monto",
    PaymentType: "TipoPago",
    Cash: "Efectivo",
    DownPayment: "Anticipo",
    Description: "Descripción",
    Active: "Activo",
    Stockable: "Almacenable",
    LowInStock: "Bajo en stock",
    Upload: "Subir",
    Barcode: "Código de barras",
    Width: "Ancho",
    Length: "Longitud",
    Height: "Altura",
    Diameter: "Diámetro",
    Size: "Tamaño",
    ExpiryDate: "Fecha de vencimiento",
    mmddyyyy: "mm/dd/aaaa",
    scanBarcode: "escanear código para agregar ..",
    Group: "Grupo",
    Registration: "N° de registro",
    Debit: "Débito",
    Credit: "Crédito",
    DebitLBP: "Débito LBP",
    CreditLBP: "Crédito LBP",
    DebitUSD: "Débito USD",
    CreditUSD: "Crédito USD",
    Charges: "Cargos",
    AllocateCharges: "Asignar cargos",
    CartDiscounts: "Descuentos carrito",
    SubTotal: "SUB Total",
    InvoiceDiscount: "DescuentoFactura",
    DiscountType: "TipoDescuento",
    General: "General",
    Prices: "Precios",
    Units: "Unidades",
    Brand: "Marca",
    Season: "Temporada",
    RaiseBy: "AumentarPor",
    BoxColor: "ColorCaja",
    ServiceProduct: "ProductoServicio",
    SimpleProduct: "ProductoSimple",
    SimpleService: "ServicioSimple",
    // Specific forms
    JournalVoucher: "Comprobante diario",
    AccountRegistration: "Registro de cuenta",
    Delivery: "Entrega",
    CashTransfer: "Transferencia de efectivo",
    ApplyPaymentToInvoice: "Aplicar pago a factura",
    Employee: "Empleado",
    Salary: "Salario",
    Supplier: "Proveedor",
    PurchaseInvoice: "Factura de compra",
    PurchaseReturn: "Devolución de compra",
    PurchaseOrder: "Orden de compra",
    Customer: "Cliente",
    SalesInvoice: "Factura de venta",
    SalesReturn: "Devolución de venta",
    SalesOrder: "Orden de venta",
    ExpenseAccount: "Cuenta de gastos",
    ExpenseSupplier: "Proveedor de gastos",
    ExpenseInvoice: "Factura de gastos",
    StockControl: "Control de stock",
    StockTransfer: "Transferencia de stock",
   
    Opening: "Apertura",
    Category: "Categoría",
    VATGroup: "GrupoIVA",
    Pcs: "Pzs",
    FromWarehouse: "Del almacén",
    ToWarehouse: "Al almacén",
    SelectProducts: "Seleccionar productos",
    NetQuantity: "Ctdad neta",
    SchedulePayments: "Programar pagos",
    Variation: "Variación",
    View: "Ver",
    In: "En"
};

const portugueseForms = {
    // Common
    ID: "ID",
    Ref: "Ref",
    Serial: "Série",
    CreatedAt: "Criado em",
    Date: "Data",
    Account: "Conta",
    Variance: "Variância",
    onAccount: "emConta",
    Close: "Fechar",
    InvoiceReceipts: "Recibos de fatura",
    In: "Entrada",
    Out: "Saída",
    StockCount: "Inventário",
    Type: "Tipo",
    UnitCost: "Custo unitário",
    SelectAccount: "Selecione a conta:",
    Expense: "Despesa",
    LBP: "LBP",
    USD: "USD",
    Weekly: "Semanal",
    Monthly: "Mensal",
    Yearly: "Anual",
    CartLockedMessage: "Nota: Carrinho bloqueado, remova a afetação de custos para desbloquear",
    delivery: "Entrega",
    Purchase: "Compra",
    Payment: "Pagamento",
    Status: "Estado",
    Details: "Detalhes",
    FromCash: "Da caixa",
    ToCash: "Para caixa",
    Actions: "Ações",
    NoData: "Sem dados",
    Select: "Selecionar...",
    Name: "Nome",
    Phone: "Telefone",
    Address: "Endereço",
    isActive: "estáAtivo",
    isAuxiliary: "éAuxiliar",
    Add: "Adicionar",
    Save: "Salvar",
    Branch: "Filial",
    Project: "Projeto",
    Reference: "Referência",
    Optional: "Opcional",
    Warehouse: "Armazém",
    Products: "Produtos",
    Unit: "Unidade",
    Quantity: "Quantidade",
    FreeQty: "Qtd grátis",
    Cost: "Custo",
    Price: "Preço",
    Discount: "Desconto",
    Total: "Total",
    VAT: "IVA",
    NetTotal: "Total Líquido",
    Percentage: "Percentagem",
    Currency: "Moeda",
    Rate: "Taxa",
    Amount: "Montante",
    PaymentType: "TipoPagamento",
    Cash: "Dinheiro",
    DownPayment: "Adiantamento",
    Description: "Descrição",
    Active: "Ativo",
    Stockable: "Estocável",
    LowInStock: "Baixo em stock",
    Upload: "Carregar",
    Barcode: "Código de barras",
    Width: "Largura",
    Length: "Comprimento",
    Height: "Altura",
    Diameter: "Diâmetro",
    Size: "Tamanho",
    ExpiryDate: "Data de validade",
    mmddyyyy: "mm/dd/aaaa",
    scanBarcode: "escanear código para adicionar ..",
    Group: "Grupo",
    Registration: "N° de registo",
    Debit: "Débito",
    Credit: "Crédito",
    DebitLBP: "Débito LBP",
    CreditLBP: "Crédito LBP",
    DebitUSD: "Débito USD",
    CreditUSD: "Crédito USD",
    Charges: "Encargos",
    AllocateCharges: "Alocar encargos",
    CartDiscounts: "Descontos carrinho",
    SubTotal: "SUB Total",
    InvoiceDiscount: "DescontoFatura",
    DiscountType: "TipoDesconto",
    General: "Geral",
    Prices: "Preços",
    Units: "Unidades",
    Brand: "Marca",
    Season: "Temporada",
    RaiseBy: "AumentarPor",
    BoxColor: "CorCaixa",
    ServiceProduct: "ProdutoServiço",
    SimpleProduct: "ProdutoSimples",
    SimpleService: "ServiçoSimples",
    // Specific forms
    JournalVoucher: "Comprovante diário",
    AccountRegistration: "Registo de conta",
    Delivery: "Entrega",
    CashTransfer: "Transferência de dinheiro",
    ApplyPaymentToInvoice: "Aplicar pagamento à fatura",
    Employee: "Funcionário",
    Salary: "Salário",
    Supplier: "Fornecedor",
    PurchaseInvoice: "Fatura de compra",
    PurchaseReturn: "Devolução de compra",
    PurchaseOrder: "Ordem de compra",
    Customer: "Cliente",
    SalesInvoice: "Fatura de venda",
    SalesReturn: "Devolução de venda",
    SalesOrder: "Ordem de venda",
    ExpenseAccount: "Conta de despesas",
    ExpenseSupplier: "Fornecedor de despesas",
    ExpenseInvoice: "Fatura de despesas",
    StockControl: "Controlo de stock",
    StockTransfer: "Transferência de stock",
    StockCount: "Contagem de stock",
    Opening: "Abertura",
    Category: "Categoria",
    VATGroup: "GrupoIVA",
    Pcs: "Pçs",
    FromWarehouse: "Do armazém",
    SelectProducts: "Selecionar produtos",
    ToWarehouse: "Para armazém",
    View: "Ver",
    NetQuantity: "Qtd líquida",
    SchedulePayments: "Agendar pagamentos",
    Variation: "Variação",
     currency: "Moeda",
    In: "Em"
};

const brazilianPortugueseForms = {
    // Common
    ID: "ID",
    Ref: "Ref",
    Expense: "Despesa",
    Serial: "Série",
    CreatedAt: "Criado em",
    Date: "Data",
    Account: "Conta",
    SchedulePayments: "Agendar pagamentos",
    SelectAccount: "Selecione a conta:",
    UnitCost: "Custo unitário",
    onAccount: "naConta", 
    Variance: "Variação",
    InvoiceReceipts: "Comprovantes de nota fiscal",
    ApplyPaymentToInvoice: "Aplicar pagamento à nota fiscal",
    Type: "Tipo",
    StockCount: "Contagem de estoque",
    LBP: "LBP",
    USD: "USD",
    Purchase: "Compra",
    Payment: "Pagamento",
    Weekly: "Semanal",
    Monthly: "Mensal", 
    Yearly: "Anual",
    CartLockedMessage: "Aviso: Carrinho travado, remova a alocação de taxas para destravar",
    Status: "Status",
    Details: "Detalhes",
    Actions: "Ações",
    NoData: "Sem dados",
    Select: "Selecionar...",
    View: "Ver",
    Name: "Nome",
    FromCash: "Do caixa",
    ToCash: "Para caixa",
    Phone: "Telefone",
    Close: "Fechar",
    Address: "Endereço",
    isActive: "estáAtivo",
    isAuxiliary: "éAuxiliar",
    Add: "Adicionar",
    Save: "Salvar",
    Branch: "Filial",
    Project: "Projeto",
    Reference: "Referência",
    In: "Entrada",  
    Out: "Saída",
    Optional: "Opcional",
    SelectProducts: "Selecionar produtos",  
    Warehouse: "Depósito",
    Products: "Produtos",
    Unit: "Unidade",
    Quantity: "Quantidade",
    FreeQty: "Qtd grátis",
    Cost: "Custo",
    Price: "Preço",
    Discount: "Desconto",
    Total: "Total",
    VAT: "Imposto",
    NetTotal: "Total Líquido",
    Percentage: "Porcentagem",
    Currency: "Moeda",
    Rate: "Taxa",
    Amount: "Valor",
    PaymentType: "TipoPagamento",
    Cash: "Dinheiro",
    DownPayment: "Adiantamento",
    Description: "Descrição",
    Active: "Ativo",
    Stockable: "Estocável",
    LowInStock: "Baixo em estoque",
    Upload: "Carregar",
    Barcode: "Código de barras",
    Width: "Largura",
    Length: "Comprimento",
    Height: "Altura",
    Diameter: "Diâmetro",
    Size: "Tamanho",
    ExpiryDate: "Data de validade",
    mmddyyyy: "mm/dd/aaaa",
    scanBarcode: "escanear código para adicionar ..",
    Group: "Grupo",
    Registration: "N° de registro",
    Debit: "Débito",
    Credit: "Crédito",
    DebitLBP: "Débito LBP",
    CreditLBP: "Crédito LBP",
    DebitUSD: "Débito USD",
    CreditUSD: "Crédito USD",
    Charges: "Encargos",
    AllocateCharges: "Alocar encargos",
    CartDiscounts: "Descontos carrinho",
    SubTotal: "SUB Total",
    InvoiceDiscount: "DescontoFatura",
    DiscountType: "TipoDesconto",
    General: "Geral",
    Prices: "Preços",
    Units: "Unidades",
    Brand: "Marca",
    Season: "Temporada",
    RaiseBy: "AumentarPor",
    BoxColor: "CorCaixa",
    ServiceProduct: "ProdutoServiço",
    SimpleProduct: "ProdutoSimples",
    SimpleService: "ServiçoSimples",
    // Specific forms
    JournalVoucher: "Comprovante diário",
    AccountRegistration: "Registro de conta",
    Delivery: "Entrega",
    CashTransfer: "Transferência de dinheiro",

    Employee: "Funcionário",
    Salary: "Folha de pagamento",
    Supplier: "Fornecedor",
    PurchaseInvoice: "Nota fiscal de compra",
    PurchaseReturn: "Devolução de compra",
    PurchaseOrder: "Pedido de compra",
    Customer: "Cliente",
    SalesInvoice: "Nota fiscal de venda",
    SalesReturn: "Devolução de venda",
    SalesOrder: "Pedido de venda",
    ExpenseAccount: "Conta de despesa",
    ExpenseSupplier: "Fornecedor de despesa",
    ExpenseInvoice: "Nota fiscal de despesa",
    StockControl: "Controle de estoque",
    StockTransfer: "Transferência de estoque",
    StockCount: "Contagem de estoque",
    Opening: "Abertura",
    Category: "Categoria",
    VATGroup: "Grupo de impostos",
    Pcs: "Pçs",
    FromWarehouse: "Do depósito",
    ToWarehouse: "Para depósito",
    NetQuantity: "Qtd líquida",
    Variation: "Variação",
    delivery: "Entrega",
     currency: "Moeda",
    In: "Em"
};  

const englishContent = {
  ID: "ID",
  JvID: "JV-ID",
  Code: "Code",
  SessionId: "Session-ID",
  RebuildStock: "Rebuild Stock",
  ContentOfTabPane: "Content of Tab Pane",
  ChooseLanguage: "Choose Language",
  User: "User",
  Cumulative: "Cumulative",
  NumberOfTables: "Number Of Tables",
  UserName: "User Name",
  Rate: "Rate",
  Role: "Role",
  Company: "Company",
  Year: "Year",
  Tabs: "Tabs",
  Symbol: "Symbol",
  Equation: "Equation",
  CreatedAt: "CreatedAt",    
  Stock: "Stock", 
  InAnERPSystem: "In an ERP system, the types of costs typically refer to the methods of inventory valuation or costing used to calculate the cost of goods.",
   Method: "Method",
  Save: "Save",
  Action: "Action",
  Trash: "Trash",
  Price: "Price",
  Type: "Type",
  Assets: "Assets",
  Serial: "Serial",
  Liabilities: "Liabilities",
  Equity: "Equity",
  LiabilitiesEquity: "Liabilities & Equity",
  Payment: "Payment",
  Account: "Account",
  Delivery: "Delivery",
  TotalIn: "Total In",
  TotalOut: "Total Out",
  OpeningDebit: "Opening.Debit",
  OpeningCredit: "Opening.Credit",
  Details: "Details",
  Debit: "Debit",
  Credit: "Credit",
  Status: "Status",
  View: "View",
  Edit: "Edit",
  Void: "Void",
  Sales: "Sales",
  Orders: "Orders",  
  SalesRevenue: "Sales Revenue",
  Ref: "Ref#",   
  ShowDebtors: "Show Debtors",
  ShowCreditors: "Show Creditors",
  Date: "Date",
  ToAccount: "To Account",
  Currency: "Currency",
  Total: "Total",
  LBP: "LBP",
  USD: "USD",
  Actions: "Actions",
  Name: "Name",
  Group: "Group",
  Auxiliary: "Auxiliary",
  Nature: "Nature",
  Edt: "Edt",
  Sys: "Sys",
  Quantity: "Quantity",

  Phone: "Phone",
  Address: "Address",
  BalanceLBP: "Balance LBP",
  BalanceUSD: "Balance USD",
  Warehouse: "Warehouse",
  ToWarehouse: "To Warehouse",
  barcode: "barcode",
  category: "category",
  unit: "unit",
  quantity: "quantity",
  cost: "cost",
  price: "price",
  Vat: "Vat",
  TrialBalance: "Trial Balance",
  AccountStatement: "Account Statement",
  BalanceSheet: "Balance Sheet",
  CashFlow: "Cash Flow",
  IncomeStatement: "Income Statement",
  BalanceByTree: "Balance By Tree",
  TotalDebit: "TotalDebit",
  TotalCredit: "TotalCredit",
  SalesByInvoice: "Sales By Invoice",
  SalesByOrder: "Sales By Order",
  SalesByItem: "Sales By Item",
  SalesByItemGrouped: "Sales By Item Grouped",
  SalesBySerial: "Sales By Serial",
  ProfitLoss: "Profit & Loss",
  CustomerPriceList: "Customer Price List",
  ReturnByInvoice: "ReturnByInvoice",
  StockMovement: "Stock Movement",
  StockValue: "Stock Value",
  LowInStock: "Low In Stock",
  Sessions: "Sessions",
  UserLogs: "User Logs",
  unBalancedJV: "unBalanced JV",
  missingAccount: "missing Account",
  RebuiltStock: "Rebuilt Stock",
  RecalculateQuantityMessage: "This method will recalculate the quantity of each product across warehouse.",
  ProcessTimeMessage: "Please note that this process may take some time to complete.",
  OpeningBalance: "Opening Balance",
  ViewJV: "View JV",
  OpeningStock: "Opening Stock",
  OpeningBalanceDescription: "The opening balance represents the initial account balance carried forward at the start of a new financial year. This setup is done only once at the beginning of the year to ensure accurate tracking of financial records.",
  OpeningStockDescription: "Opening Stock Invoice typically includes both the quantity and the opening cost (or opening value) for inventory items at the start of an accounting period.",
  Tab: "Tab",
  Products: "Products",

  CostChanges: "Cost Changes",
  Product: "Product",
  PrintingOptions: "Printing Options",
  Language: "Language",
  POSOptions: "POS Options",
  DineInOptions: "Dine In Options",
  MainCurrency: "Main Currency*",
  LebaneseLira: "lebanese lira",
  SecondaryCurrency: "Secondary Currency*",
  Balance: "Balance",
  USdollar: "us dollar",
  Receipt: "Receipt",
  PurchaseReturn: "Purchase Return",
  InFlow: "In Flow",
  Purchases: "Purchases",
  Expenses: "Expenses",
  Payments: "Payments",
  SalesReturn: "Sales Return",
  CashVariance: "Cash Variance",
  OutFlow: "Out Flow",
  CashBalance: "Cash Balance",
  SalesDiscounts: "Sales Discounts",
  CostOfGoodsSold: "Cost of Goods Sold",
  PurchaseDiscounts: "Purchase Discounts",
  GrossProfit: "Gross Profit",
  OperatingExpenses: "Operating Expenses",
  NetIncome: "Net Income",
  ProfitAndLoss: "Profit & Loss",
  LastModified: "Last Modified",
  ModifiedBy: "Modified By",
  Cost: "Cost",
  Discount: "Discount",
  Profit: "Profit",
  In: "IN",
  Out: "OUT",
  Variance: "Variance",
  Closing: "Closing",
  Opening: "Opening",
  Closed: "Closed",
  Opened: "Opened",
   vatGroup: "VAT Group",
  downloadExcelTemplate: "Download Excel Template",
  importExcel: "Import Excel",
  Simple: "Simple",
  RawMaterial: "Raw Material",
  Compound: "Compound",
  Serialized: "Serialized",
  Service: "Service",
  Production: "Production",
  RaiseBy: "Raise By",
   PrintName: "Print Name",
  PrintAddress: "Print Address",
  PrintPhone: "Print Phone",
  PrintDetails: "Print Details",
  PrintDiscount: "Print Discount",
  PrintItemPrice: "Print Item Price",
  PrintCategory: "Print Category",
  PrintingName: "Printing Name",
  PrintingAddress: "Printing Address",
  PrintingPhone: "Printing Phone",
  ReverseItemOrder: "Reverse Item Order",
  MoneyExchange: "Money Exchange",
  UseCustomerPrice: "Use Customer Price",
  ShowRateOnInvoice: "Show Rate on Invoice",
  ShowPriceInPOSItemsBox: "Show Price in POS Items Box",
  ShowCostInPOSItemsBox: "Show Cost in POS Items Box",
  StartSessionAtZero: "Start Session at Zero",
  ShowCostInCart: "Show Cost in Cart",
  NumberOfTabs: "Number of Tabs"
};

const arabicContent = {
  ID: "المعرف",
  JvID: "معرف سند القيد",
  CreatedAt: "تم الإنشاء في",
  ChooseLanguage: "اختر اللغة",
  Code: "كود",
  Rate: "السعر",
  RebuildStock: "إعادة بناء المخزون",
  User: "مستخدم",
  NumberOfTables: "عدد الجداول",
  Action: "إجراء",
  InAnERPSystem: "في نظام تخطيط موارد المؤسسات، تشير أنواع التكاليف عادةً إلى طرق تقييم المخزون أو التكاليف المستخدمة لحساب تكلفة البضائع.",
  SessionId: "معرف الجلسة",
  Cumulative: "تراكمي",
   UserName: "اسم المستخدم",
  Role: "الدور",
  Company: "الشركة",
  Year: "السنة",
  Tabs: "علامات التبويب",
  Symbol: "الرمز",
  Equation: "المعادلة",
  Method: "طريقة",  // (Tariqa)
  Save: "حفظ"  ,
  Stock: "المخزون",
  ContentOfTabPane: "محتوى لوحة التبويب",
  Trash: "حذف",
  peningDebit: "مدين افتتاحي",  // (Mudeen iftitahi)
  OpeningCredit: "دائن افتتاحي",  // (Da'in iftitahi)
  Type: "النوع",
  Quantity: "الكمية" ,
  Price: "السعر",
  Payment: "الدفع",
  Account: "الحساب",
  Delivery: "التوصيل",
  Debit: "مدين", 
  Credit: "دائن",
  TotalIn: "إجمالي الداخل",
  TotalOut: "إجمالي الخارج",
  Details: "التفاصيل",
  ShowDebtors: "عرض المدينين",  
  ShowCreditors: "عرض الدائنين",
  Status: "الحالة",
  View: "عرض",
  Edit: "تعديل",
  Void: "إلغاء",
  Sales: "المبيعات",
  Orders: "الطلبات",
  SalesRevenue: "إيرادات المبيعات",
  Ref: "#المرجع",
  Date: "التاريخ",
  ToAccount: "إلى الحساب",
  Currency: "العملة",
  Total: "المجموع",
  LBP: "ل.ل",
  USD: "دولار",
  Actions: "الإجراءات",
  Name: "الاسم",
  Group: "المجموعة",
  Auxiliary: "مساعد",
  Nature: "الطبيعة",
  Edt: "تعديل",
  Sys: "النظام",
 
  Phone: "الهاتف",
  Address: "العنوان",
  BalanceLBP: "الرصيد ل.ل",
  BalanceUSD: "الرصيد دولار",
  Warehouse: "المستودع",
  ToWarehouse: "إلى المستودع",
  barcode: "الباركود",
  category: "الفئة",
  unit: "الوحدة",
  quantity: "الكمية",
  cost: "التكلفة",
  price: "السعر",
  Vat: "الضريبة",
  TrialBalance: "ميزان المراجعة",
  AccountStatement: "كشف الحساب",
  BalanceSheet: "الميزانية العمومية",
  CashFlow: "التدفق النقدي",
  IncomeStatement: "بيان الدخل",
  BalanceByTree: "الرصيد حسب الشجرة",
  TotalDebit: "إجمالي المدين",
  TotalCredit: "إجمالي الدائن",
  SalesByInvoice: "المبيعات حسب الفاتورة",
  SalesByOrder: "المبيعات حسب الطلب",
  SalesByItem: "المبيعات حسب الصنف",
  SalesByItemGrouped: "المبيعات المجمعة حسب الصنف",
  SalesBySerial: "المبيعات حسب السيريال",
  ProfitLoss: "الأرباح والخسائر",
  CustomerPriceList: "قائمة أسعار العملاء",
  ReturnByInvoice: "مرتجع حسب الفاتورة",
  StockMovement: "حركة المخزون",
  StockValue: "قيمة المخزون",
  LowInStock: "منخفض في المخزون",
  Sessions: "الجلسات",
  UserLogs: "سجلات المستخدمين",
  unBalancedJV: "سند غير متوازن",
  missingAccount: "حساب مفقود",
  RebuiltStock: "إعادة بناء المخزون",
  RecalculateQuantityMessage: "هذه الطريقة ستعيد حساب كمية كل منتج عبر المستودع.",
  ProcessTimeMessage: "يرجى ملاحظة أن هذه العملية قد تستغرق بعض الوقت لإكمالها.",
  OpeningBalance: "الرصيد الافتتاحي",
  ViewJV: "عرض سند",
  OpeningStock: "المخزون الافتتاحي",
  OpeningBalanceDescription: "يمثل الرصيد الافتتاحي الرصيد الأولي المحمول في بداية السنة المالية الجديدة. يتم إعداد هذا مرة واحدة فقط في بداية السنة لضمان تتبع دقيق للسجلات المالية.",
  OpeningStockDescription: "عادةً ما تتضمن فاتورة المخزون الافتتاحي كل من الكمية وتكلفة الافتتاح (أو قيمة الافتتاح) لأصناف المخزون في بداية الفترة المحاسبية.",
  Tab: "تبويب",
  Products: "المنتجات",

  CostChanges: "تغييرات التكلفة",
  Product: "المنتج",
  PrintingOptions: "خيارات الطباعة",
  Language: "اللغة",
  POSOptions: "خيارات نقطة البيع",
  DineInOptions: "خيارات تناول الطعام في المطعم",
  MainCurrency: "العملة الرئيسية*",
  LebaneseLira: "ليرة لبنانية",
  SecondaryCurrency: "العملة الثانوية*",
  Balance: "الرصيد",
  USdollar: "دولار أمريكي",
  Assets: "الأصول", 
Liabilities: "الخصوم", 
Equity: "حقوق الملكية", 
LiabilitiesEquity: "الخصوم وحقوق الملكية" ,

  Receipt: "إيصال",
  PurchaseReturn: "مرتجع شراء",
  InFlow: "تدفق داخلي",
  Purchases: "مشتريات",
  Expenses: "مصروفات",
  Payments: "مدفوعات",
  SalesReturn: "مرتجع مبيعات",
  CashVariance: "فارق نقدي",
  OutFlow: "تدفق خارجي",
  CashBalance: "رصيد نقدي",
  SalesDiscounts: "خصومات المبيعات",
  CostOfGoodsSold: "تكلفة البضاعة المباعة",
  PurchaseDiscounts: "خصومات المشتريات",
  GrossProfit: "إجمالي الربح",
  OperatingExpenses: "مصاريف التشغيل",
  NetIncome: "صافي الدخل",
  ProfitAndLoss: "حساب الأرباح والخسائر",
  LastModified: "آخر تعديل",  // (Akhir ta'deel)
ModifiedBy: "تم التعديل بواسطة",
 Cost: "التكلفة",  // (Al-taklifa)
  Discount: "الخصم",
  Profit: "ربح",
  In: "داخل",  // (Dakhil)
  Out: "خارج",
  Variance: "التباين",       // (Al-tabayun)
  Closing: "الإقفال",        // (Al-iqfal)
  Opening: "الافتتاح",      // (Al-iftitah)
  Closed: "مقفل",           
  Opened: "مفتوح",
  vatGroup: "مجموعة ضريبة القيمة المضافة",
  downloadExcelTemplate: "تنزيل قالب إكسل",
  importExcel: "استيراد من إكسل",
  Simple: "بسيط",  // (Baseet)
  RawMaterial: "مادة خام",  // (Madda kham)
  Compound: "مركب",  // (Murakkab)
  Serialized: "مسلسل",  // (Musalsal)
  Service: "خدمة",  // (Khidma)
  Production: "إنتاج",  // (Intaj)
  RaiseBy: "زيادة بمقدار",  // (Ziyada bi-miqtar)    
  PrintName: "طباعة الاسم",
  PrintAddress: "طباعة العنوان",
  PrintPhone: "طباعة الهاتف",
  PrintDetails: "طباعة التفاصيل",
  PrintDiscount: "طباعة الخصم",
  PrintItemPrice: "طباعة سعر الصنف",
  PrintCategory: "طباعة الفئة",
  PrintingName: "جاري طباعة الاسم",
  PrintingAddress: "جاري طباعة العنوان",
  PrintingPhone: "جاري طباعة الهاتف",
  ReverseItemOrder: "عكس ترتيب العناصر",
  MoneyExchange: "صرف العملات",
  UseCustomerPrice: "استخدام سعر العميل",
  ShowRateOnInvoice: "عرض السعر على الفاتورة",
  ShowPriceInPOSItemsBox: "عرض السعر في مربع عناصر نقطة البيع",
  ShowCostInPOSItemsBox: "عرض التكلفة في مربع عناصر نقطة البيع",
  StartSessionAtZero: "بدء الجلسة من الصفر",
  ShowCostInCart: "عرض التكلفة في السلة",
  NumberOfTabs: "عدد علامات التبويب"       
};

const frenchContent = {
  ID: "ID",
  JvId: "N° PV",
  CreatedAt: "Créé le",
  ChooseLanguage: "Choisir la langue",
  Action: "Action",
  Rate: "Taux",
  Code: "Code",
  NumberOfTables: "Nombre de tables",
  SessionId: "ID de session",
  InAnERPSystem: "Dans un système ERP, les types de coûts font généralement référence aux méthodes d'évaluation des stocks ou de calcul des coûts utilisées pour déterminer le coût des marchandises.",
  RebuildStock: "Reconstituer le stock",
  UserName: "Nom d'utilisateur",
  Role: "Rôle",
  Company: "Société",
  Year: "Année",
  Tabs: "Onglets",
  Symbol: "Symbole",
  Equation: "Équation",
   Method: "Méthode",
  Save: "Enregistrer",
  ContentOfTabPane: "Contenu de l'onglet",
  Type: "Type",
  Stock: "Stock",
  User: "Utilisateur",
  Payment: "Paiement",
  Cumulative: "Cumulatif",
  Price: "Prix",
  OpeningDebit: "Débit.Ouverture",
  Quantity: "Quantité",
  OpeningCredit: "Crédit.Ouverture",
  Trash: "Corbeille",
  Debit: "Débit",
  Credit: "Crédit",
  Account: "Compte",
  Delivery: "Livraison",
  TotalIn: "Total Entrée",
  TotalOut: "Total Sortie",
  Details: "Détails",
  Status: "Statut",
  View: "Voir",
  Edit: "Modifier",
  Void: "Annuler",
  Sales: "Ventes",
  Orders: "Commandes",
  SalesRevenue: "Chiffre d'affaires",
  ShowDebtors: "Afficher les débiteurs",
  ShowCreditors: "Afficher les créanciers",
  Ref: "Réf#",
  Date: "Date",
  ToAccount: "Vers compte",
  Currency: "Devise",
  Total: "Total",
  LBP: "LBP",
  USD: "USD",
  Actions: "Actions",
  Name: "Nom",
  Group: "Groupe",
  Auxiliary: "Auxiliaire",
  Nature: "Nature",
  Edt: "Mod.",
  Sys: "Syst.",

  Phone: "Téléphone",
  Address: "Adresse",
  BalanceLBP: "Solde LBP",
  BalanceUSD: "Solde USD",
  Warehouse: "Entrepôt",
  ToWarehouse: "Vers entrepôt",
  barcode: "code-barres",
  category: "catégorie",
  unit: "unité",
  quantity: "quantité",
  cost: "coût",
  price: "prix",
  Vat: "TVA",
  TrialBalance: "Balance de vérification",
  AccountStatement: "Relevé de compte",
  BalanceSheet: "Bilan",
  CashFlow: "Flux de trésorerie",
  IncomeStatement: "Compte de résultat",
  BalanceByTree: "Solde par arborescence",
  TotalDebit: "Total Débit",
  TotalCredit: "Total Crédit",
  SalesByInvoice: "Ventes par facture",
  SalesByOrder: "Ventes par commande",
  SalesByItem: "Ventes par article",
  SalesByItemGrouped: "Ventes groupées par article",
  SalesBySerial: "Ventes par série",
  ProfitLoss: "Profit et perte",
  CustomerPriceList: "Liste de prix clients",
  ReturnByInvoice: "Retour par facture",
  StockMovement: "Mouvement de stock",
  StockValue: "Valeur du stock",
  LowInStock: "Stock faible",
  Sessions: "Sessions",
  UserLogs: "Journaux utilisateur",
  unBalancedJV: "Journal non équilibré",
  missingAccount: "Compte manquant",
  RebuiltStock: "Stock reconstruit",
  RecalculateQuantityMessage: "Cette méthode recalculera la quantité de chaque produit dans l'entrepôt.",
  ProcessTimeMessage: "Veuillez noter que ce processus peut prendre un certain temps.",
  OpeningBalance: "Solde d'ouverture",
  ViewJV: "Voir journal",
  OpeningStock: "Stock d'ouverture",
  OpeningBalanceDescription: "Le solde d'ouverture représente le solde initial reporté au début d'un nouvel exercice financier. Cette configuration est effectuée une seule fois au début de l'année pour assurer un suivi précis des enregistrements financiers.",
  OpeningStockDescription: "La facture de stock d'ouverture comprend généralement à la fois la quantité et le coût d'ouverture (ou la valeur d'ouverture) pour les articles d'inventaire au début d'une période comptable.",
  Tab: "Onglet",
  Products: "Produits",
 
  CostChanges: "Changements de coût",
  Product: "Produit",
  PrintingOptions: "Options d'impression",
  Language: "Langue",
  POSOptions: "Options PDV",
  DineInOptions: "Options sur place",
  MainCurrency: "Devise principale*",
  LebaneseLira: "livre libanaise",
  SecondaryCurrency: "Devise secondaire*",
  Balance: "Solde",
  USdollar: "dollar américain",
  Assets: "Actifs",
Liabilities: "Passifs",
Equity: "Capitaux propres",
LiabilitiesEquity: "Passifs et capitaux propres",

  Receipt: "Reçu",
  PurchaseReturn: "Retour d'achat",
  InFlow: "Entrées",
  Purchases: "Achats",
  Expenses: "Dépenses",
  Payments: "Paiements",
  SalesReturn: "Retour de vente",
  CashVariance: "Écart de caisse",
  OutFlow: "Sorties",
  CashBalance: "Solde de caisse",
   SalesDiscounts: "Remises sur ventes",
  CostOfGoodsSold: "Coût des marchandises vendues",
  PurchaseDiscounts: "Remises sur achats",
  GrossProfit: "Bénéfice brut",
  OperatingExpenses: "Frais d'exploitation",
  NetIncome: "Revenu net",
  ProfitAndLoss: "Compte de résultat",
  LastModified: "Dernière modification",
ModifiedBy: "Modifié par",
 Cost: "Coût",
  Discount: "Remise",
  Profit: "Bénéfice",
   In: "ENTRÉE",
  Out: "SORTIE",
  Variance: "Écart",
  Closing: "Clôture",
  Opening: "Ouverture",
  Closed: "Fermé",
  Opened: "Ouvert",
  vatGroup: "Groupe TVA",
  downloadExcelTemplate: "Télécharger le modèle Excel",
  importExcel: "Importer Excel",
   Simple: "Simple",
  RawMaterial: "Matière première",
  Compound: "Composé",
  Serialized: "Sérialisé",
  Service: "Service",
  Production: "Production",
  RaiseBy: "Augmenter de",
  PrintName: "Imprimer le nom",
  PrintAddress: "Imprimer l'adresse",
  PrintPhone: "Imprimer le téléphone",
  PrintDetails: "Imprimer les détails",
  PrintDiscount: "Imprimer la remise",
  PrintItemPrice: "Imprimer le prix de l'article",
  PrintCategory: "Imprimer la catégorie",
  PrintingName: "Impression du nom",
  PrintingAddress: "Impression de l'adresse",
  PrintingPhone: "Impression du téléphone",
  ReverseItemOrder: "Inverser l'ordre des articles",
  MoneyExchange: "Change de devises",
  UseCustomerPrice: "Utiliser le prix client",
  ShowRateOnInvoice: "Afficher le taux sur la facture",
  ShowPriceInPOSItemsBox: "Afficher le prix dans la boîte d'articles PDV",
  ShowCostInPOSItemsBox: "Afficher le coût dans la boîte d'articles PDV",
  StartSessionAtZero: "Commencer la session à zéro",
  ShowCostInCart: "Afficher le coût dans le panier",
  NumberOfTabs: "Nombre d'onglets"
};

const spanishContent = {
  ID: "ID",
  JvId: "ID-AC",
  ChooseLanguage: "Elegir idioma",
  Action: "Acción",
  Cumulative: "Acumulado",
  Rate: "Tasa",
  Code: "Código",
  NumberOfTables: "Número de mesas",
  InAnERPSystem: "En un sistema ERP, los tipos de costos normalmente se refieren a los métodos de valoración de inventario o costeo utilizados para calcular el costo de los bienes.",
  Method: "Método",
  UserName: "Nombre de usuario",
  Role: "Rol",
  Company: "Empresa",
  Year: "Año",
  Tabs: "Pestañas",
  Symbol: "Símbolo",
  Equation: "Ecuación",
  Save: "Guardar",
  Stock: "Existencias",
  SessionId: "ID de sesión",
  RebuildStock: "Reconstruir inventario",
  ContentOfTabPane: "Contenido de la pestaña",
  CreatedAt: "Creado el",
  User: "Usuario",
  Quantity: "Cantidad",
  Price: "Precio",
  Type: "Tipo",
  Payment: "Pago",
  Account: "Cuenta",
  Delivery: "Entrega",
  OpeningDebit: "Débito.Apertura",
  OpeningCredit: "Crédito.Apertura",
  Trash: "Papelera",
  TotalIn: "Total Entrada",
  TotalOut: "Total Salida",
  Details: "Detalles",
  Status: "Estado",
  Debit: "Débito",
  Credit: "Crédito",
  View: "Ver",
  Edit: "Editar",
  Void: "Anular",
  Sales: "Ventas",
  ShowDebtors: "Mostrar deudores",
  ShowCreditors: "Mostrar acreedores",
  Orders: "Pedidos",
  SalesRevenue: "Ingresos por ventas",
  Ref: "Ref#",
  Date: "Fecha",
  ToAccount: "A cuenta",
  Currency: "Moneda",
  Total: "Total",
  LBP: "LBP",
  USD: "USD",
  Actions: "Acciones",
  Name: "Nombre",
  Group: "Grupo",
  Auxiliary: "Auxiliar",
  Nature: "Naturaleza",
  Edt: "Ed.",
  Sys: "Sis.",

  Phone: "Teléfono",
  Address: "Dirección",
  BalanceLBP: "Saldo LBP",
  BalanceUSD: "Saldo USD",
  Warehouse: "Almacén",
  ToWarehouse: "A almacén",
  barcode: "código de barras",
  category: "categoría",
  unit: "unidad",
  quantity: "cantidad",
  cost: "costo",
  price: "precio",
  Vat: "IVA",
  TrialBalance: "Balance de comprobación",
  AccountStatement: "Estado de cuenta",
  BalanceSheet: "Balance general",
  CashFlow: "Flujo de efectivo",
  IncomeStatement: "Estado de resultados",
  BalanceByTree: "Saldo por árbol",
  TotalDebit: "Total Débito",
  TotalCredit: "Total Crédito",
  SalesByInvoice: "Ventas por factura",
  SalesByOrder: "Ventas por pedido",
  SalesByItem: "Ventas por artículo",
  SalesByItemGrouped: "Ventas agrupadas por artículo",
  SalesBySerial: "Ventas por serie",
  ProfitLoss: "Pérdidas y ganancias",
  CustomerPriceList: "Lista de precios de clientes",
  ReturnByInvoice: "Devolución por factura",
  StockMovement: "Movimiento de stock",
  StockValue: "Valor de stock",
  LowInStock: "Stock bajo",
  Sessions: "Sesiones",
  UserLogs: "Registros de usuario",
  unBalancedJV: "Diario no balanceado",
  missingAccount: "Cuenta faltante",
  RebuiltStock: "Stock reconstruido",
  RecalculateQuantityMessage: "Este método recalculará la cantidad de cada producto en el almacén.",
  ProcessTimeMessage: "Tenga en cuenta que este proceso puede tardar algún tiempo en completarse.",
  OpeningBalance: "Saldo inicial",
  ViewJV: "Ver diario",
  OpeningStock: "Stock inicial",
  OpeningBalanceDescription: "El saldo inicial representa el saldo inicial transferido al comienzo de un nuevo año financiero. Esta configuración se realiza solo una vez al comienzo del año para garantizar un seguimiento preciso de los registros financieros.",
  OpeningStockDescription: "La factura de stock inicial generalmente incluye tanto la cantidad como el costo inicial (o valor inicial) para los artículos de inventario al comienzo de un período contable.",
  Tab: "Pestaña",
  Products: "Productos",
 
  CostChanges: "Cambios de costo",
  Product: "Producto",
  PrintingOptions: "Opciones de impresión",
  Language: "Idioma",
  POSOptions: "Opciones TPV",
  DineInOptions: "Opciones para comer en el local",
  MainCurrency: "Moneda principal*",
  LebaneseLira: "lira libanesa",
  SecondaryCurrency: "Moneda secundaria*",
  Balance: "Saldo",
  USdollar: "dólar estadounidense",
  Assets: "Activos",
Liabilities: "Pasivos",
Equity: "Patrimonio",
LiabilitiesEquity: "Pasivos y patrimonio",
  Receipt: "Recibo",
  PurchaseReturn: "Devolución de compra",
  InFlow: "Entradas",
  Purchases: "Compras",
  Expenses: "Gastos",
  Payments: "Pagos",
  SalesReturn: "Devolución de venta",
  CashVariance: "Variación de caja",
  OutFlow: "Salidas",
  CashBalance: "Saldo de caja",
  SalesDiscounts: "Descuentos en ventas",
  CostOfGoodsSold: "Costo de bienes vendidos",
  PurchaseDiscounts: "Descuentos en compras",
  GrossProfit: "Utilidad bruta",
  OperatingExpenses: "Gastos de operación",
  NetIncome: "Ingreso neto",
  ProfitAndLoss: "Estado de resultados",
  LastModified: "Última modificación",
ModifiedBy: "Modificado por",
 Cost: "Costo",
  Discount: "Descuento",
  Profit: "Beneficio",
   In: "ENTRADA",
  Out: "SALIDA",
  Variance: "Variación",
  Closing: "Cierre",
  Opening: "Apertura",
  Closed: "Cerrado",
  Opened: "Abierto",
  vatGroup: "Grupo de IVA",
  downloadExcelTemplate: "Descargar plantilla Excel",
  importExcel: "Importar Excel",
  Simple: "Simple",
  RawMaterial: "Materia prima",
  Compound: "Compuesto",
  Serialized: "Serializado",
  Service: "Servicio",
  Production: "Producción",
  RaiseBy: "Aumentar en",
  PrintName: "Imprimir nombre",
  PrintAddress: "Imprimir dirección",
  PrintPhone: "Imprimir teléfono",
  PrintDetails: "Imprimir detalles",
  PrintDiscount: "Imprimir descuento",
  PrintItemPrice: "Imprimir precio del artículo",
  PrintCategory: "Imprimir categoría",
  PrintingName: "Imprimiendo nombre",
  PrintingAddress: "Imprimiendo dirección",
  PrintingPhone: "Imprimiendo teléfono",
  ReverseItemOrder: "Invertir orden de artículos",
  MoneyExchange: "Cambio de moneda",
  UseCustomerPrice: "Usar precio del cliente",
  ShowRateOnInvoice: "Mostrar tasa en factura",
  ShowPriceInPOSItemsBox: "Mostrar precio en caja de artículos TPV",
  ShowCostInPOSItemsBox: "Mostrar costo en caja de artículos TPV",
  StartSessionAtZero: "Iniciar sesión en cero",
  ShowCostInCart: "Mostrar costo en carrito",
  NumberOfTabs: "Número de pestañas"
};

const portugueseContent = {
  ID: "ID",
  JvId: "N° DC",
  Action: "Ação",
  Stock: "Stock",
  Rate: "Taxa",
  Code: "Código",
  ChooseLanguage: "Escolher idioma",
  NumberOfTables: "Número de mesas",
  InAnERPSystem: "Num sistema ERP, os tipos de custos referem-se tipicamente aos métodos de valorização de inventário ou de custeio utilizados para calcular o custo das mercadorias.",
  RebuildStock: "Reconstituir stock",
  ContentOfTabPane: "Conteúdo do separador",
  User: "Utilizador",
  Quantity: "Quantidade",
  UserName: "Nome de utilizador",
  Role: "Função",
  Company: "Empresa",
  Year: "Ano",
  Tabs: "Separadores",
  Symbol: "Símbolo",
  Equation: "Equação",
  Method: "Método",
  Save: "Guardar",
  SessionId: "ID de sessão",
  Cumulative: "Acumulado",
  CreatedAt: "Criado em",
  Price: "Preço",
  Type: "Tipo",
  Payment: "Pagamento",
  OpeningDebit: "Débito.Abertura",
  OpeningCredit: "Crédito.Abertura",
  Account: "Conta",
  Delivery: "Entrega",
  Trash: "Reciclagem",
  TotalIn: "Total Entrada",
  TotalOut: "Total Saída",
  Details: "Detalhes",
  Status: "Estado",
  Debit: "Débito",
  Credit: "Crédito",
  View: "Ver",
  Edit: "Editar",
  Void: "Anular",
  Sales: "Vendas",
  ShowDebtors: "Mostrar devedores",
  ShowCreditors: "Mostrar credores",
  Orders: "Encomendas",
  SalesRevenue: "Receitas de vendas",
  Ref: "Ref#",
  Date: "Data",
  ToAccount: "Para conta",
  Currency: "Moeda",
  Total: "Total",
  LBP: "LBP",
  USD: "USD",
  Actions: "Ações",
  Name: "Nome",
  Group: "Grupo",
  Auxiliary: "Auxiliar",
  Nature: "Natureza",
  Edt: "Ed.",
  Sys: "Sis.",

  Phone: "Telefone",
  Address: "Morada",
  BalanceLBP: "Saldo LBP",
  BalanceUSD: "Saldo USD",
  Warehouse: "Armazém",
  ToWarehouse: "Para armazém",
  barcode: "código de barras",
  category: "categoria",
  unit: "unidade",
  quantity: "quantidade",
  cost: "custo",
  price: "preço",
  Vat: "IVA",
  TrialBalance: "Balanço de verificação",
  AccountStatement: "Extrato de conta",
  BalanceSheet: "Balanço",
  CashFlow: "Fluxo de caixa",
  IncomeStatement: "Demonstração de resultados",
  BalanceByTree: "Saldo por árvore",
  TotalDebit: "Total Débito",
  TotalCredit: "Total Crédito",
  SalesByInvoice: "Vendas por fatura",
  SalesByOrder: "Vendas por encomenda",
  SalesByItem: "Vendas por item",
  SalesByItemGrouped: "Vendas agrupadas por item",
  SalesBySerial: "Vendas por série",
  ProfitLoss: "Lucros e perdas",
  CustomerPriceList: "Lista de preços de clientes",
  ReturnByInvoice: "Devolução por fatura",
  StockMovement: "Movimento de stock",
  StockValue: "Valor de stock",
  LowInStock: "Stock baixo",
  Sessions: "Sessões",
  UserLogs: "Registos de utilizador",
  unBalancedJV: "Diário não balanceado",
  missingAccount: "Conta em falta",
  RebuiltStock: "Stock reconstruído",
  RecalculateQuantityMessage: "Este método irá recalcular a quantidade de cada produto no armazém.",
  ProcessTimeMessage: "Por favor, note que este processo pode demorar algum tempo a concluir.",
  OpeningBalance: "Saldo de abertura",
  ViewJV: "Ver diário",
  OpeningStock: "Stock de abertura",
  OpeningBalanceDescription: "O saldo de abertura representa o saldo inicial transferido no início de um novo ano financeiro. Esta configuração é feita apenas uma vez no início do ano para garantir um acompanhamento preciso dos registos financeiros.",
  OpeningStockDescription: "A fatura de stock de abertura inclui tipicamente tanto a quantidade como o custo de abertura (ou valor de abertura) para artigos de inventário no início de um período contabilístico.",
  Tab: "Separador",
  Products: "Produtos",
 
  CostChanges: "Alterações de custo",
  Product: "Produto",
  PrintingOptions: "Opções de impressão",
  Language: "Idioma",
  POSOptions: "Opções POS",
  DineInOptions: "Opções para comer no local",
  MainCurrency: "Moeda principal*",
  LebaneseLira: "lira libanesa",
  SecondaryCurrency: "Moeda secundária*",
  Balance: "Saldo",
  USdollar: "dólar americano",
  Assets: "Ativos",
Liabilities: "Passivos",
Equity: "Capital próprio",
LiabilitiesEquity: "Passivos e capital próprio",
  Receipt: "Recibo",
  PurchaseReturn: "Devolução de compra",
  InFlow: "Entradas",
  Purchases: "Compras",
  Expenses: "Despesas",
  Payments: "Pagamentos",
  SalesReturn: "Devolução de venda",
  CashVariance: "Diferença de caixa",
  OutFlow: "Saídas",
  CashBalance: "Saldo de caixa",
   SalesDiscounts: "Descontos em vendas",
  CostOfGoodsSold: "Custo das mercadorias vendidas",
  PurchaseDiscounts: "Descontos em compras",
  GrossProfit: "Lucro bruto",
  OperatingExpenses: "Despesas operacionais",
  NetIncome: "Resultado líquido",
  ProfitAndLoss: "Demonstração de resultados",
  LastModified: "Última alteração",
ModifiedBy: "Alterado por",
Cost: "Custo",
  Discount: "Desconto",
  Profit: "Lucro",
  In: "ENTRADA",
  Out: "SAÍDA",
  Variance: "Diferença",
  Closing: "Fecho",
  Opening: "Abertura",
  Closed: "Fechado",
  Opened: "Aberto",
  vatGroup: "Grupo de IVA",
  downloadExcelTemplate: "Descarregar modelo Excel",
  importExcel: "Importar Excel",
  Simple: "Simples",
  RawMaterial: "Matéria-prima",
  Compound: "Composto",
  Serialized: "Serializado",
  Service: "Serviço",
  Production: "Produção",
  RaiseBy: "Aumentar em",
  PrintName: "Imprimir nome",
  PrintAddress: "Imprimir morada",
  PrintPhone: "Imprimir telefone",
  PrintDetails: "Imprimir detalhes",
  PrintDiscount: "Imprimir desconto",
  PrintItemPrice: "Imprimir preço do item",
  PrintCategory: "Imprimir categoria",
  PrintingName: "A imprimir nome",
  PrintingAddress: "A imprimir morada",
  PrintingPhone: "A imprimir telefone",
  ReverseItemOrder: "Inverter ordem dos itens",
  MoneyExchange: "Câmbio monetário",
  UseCustomerPrice: "Usar preço do cliente",
  ShowRateOnInvoice: "Mostrar taxa na fatura",
  ShowPriceInPOSItemsBox: "Mostrar preço na caixa de itens POS",
  ShowCostInPOSItemsBox: "Mostrar custo na caixa de itens POS",
  StartSessionAtZero: "Iniciar sessão em zero",
  ShowCostInCart: "Mostrar custo no carrinho",
  NumberOfTabs: "Número de separadores"
};

const brazilianPortugueseContent = {
  ID: "ID",
  JvId: "ID-LC",
  User: "Usuário",
  NumberOfTables: "Número de mesas",
  Action: "Ação",
  Rate: "Taxa",
  Code: "Código",
  ChooseLanguage: "Escolher idioma",
  InAnERPSystem: "Em um sistema ERP, os tipos de custos geralmente se referem aos métodos de avaliação de estoque ou custeio utilizados para calcular o custo das mercadorias.",
  SessionId: "ID de sessão",
  ContentOfTabPane: "Conteúdo da aba", 
  CreatedAt: "Criado em",
  Stock: "Estoque",
  UserName: "Nome de usuário",
  Role: "Função",
  Company: "Empresa",
  Year: "Ano",
  Tabs: "Abas",
  Symbol: "Símbolo",
  Equation: "Equação",
  Cumulative: "Acumulado",
  Method: "Método",
  Save: "Salvar",
  RebuildStock: "Reconstruir estoque",
  Type: "Tipo",
  Price: "Preço",
  Quantity: "Quantidade",
  Payment: "Pagamento",
  Account: "Conta",
  OpeningDebit: "Débito.Abertura",
  OpeningCredit: "Crédito.Abertura",
  Delivery: "Entrega",
  Trash: "Lixeira",
  TotalIn: "Total Entrada",
  ShowDebtors: "Mostrar devedores",
  ShowCreditors: "Mostrar credores",
  TotalOut: "Total Saída",
  Debit: "Débito",
  Credit: "Crédito",
  Details: "Detalhes",
  Status: "Status",
  View: "Visualizar",
  Edit: "Editar",
  Void: "Cancelar",
  Sales: "Vendas",
  Orders: "Pedidos",
  SalesRevenue: "Receita de Vendas",
  Ref: "Ref#",
  Date: "Data",
  ToAccount: "Para conta",
  Currency: "Moeda",
  Total: "Total",
  LBP: "LBP",
  USD: "USD",
  Actions: "Ações",
  Name: "Nome",
  Group: "Grupo",
  Auxiliary: "Auxiliar",
  Nature: "Natureza",
  Edt: "Ed.",
  Sys: "Sis.",

  Phone: "Telefone",
  Address: "Endereço",
  BalanceLBP: "Saldo LBP",
  BalanceUSD: "Saldo USD",
  Warehouse: "Estoque",
  ToWarehouse: "Para estoque",
  barcode: "código de barras",
  category: "categoria",
  unit: "unidade",
  quantity: "quantidade",
  cost: "custo",
  price: "preço",
  Vat: "Impostos",
  TrialBalance: "Balanço de verificação",
  AccountStatement: "Extrato da conta",
  BalanceSheet: "Balanço patrimonial",
  CashFlow: "Fluxo de caixa",
  IncomeStatement: "Demonstração de resultados",
  BalanceByTree: "Saldo por árvore",
  TotalDebit: "Total Débito",
  TotalCredit: "Total Crédito",
  SalesByInvoice: "Vendas por nota fiscal",
  SalesByOrder: "Vendas por pedido",
  SalesByItem: "Vendas por item",
  SalesByItemGrouped: "Vendas agrupadas por item",
  SalesBySerial: "Vendas por serial",
  ProfitLoss: "Lucro e perda",
  CustomerPriceList: "Lista de preços de clientes",
  ReturnByInvoice: "Devolução por nota fiscal",
  StockMovement: "Movimentação de estoque",
  StockValue: "Valor do estoque",
  LowInStock: "Estoque baixo",
  Sessions: "Sessões",
  UserLogs: "Logs de usuário",
  unBalancedJV: "Lançamento desbalanceado",
  missingAccount: "Conta faltante",
  RebuiltStock: "Estoque reconstruído",
  RecalculateQuantityMessage: "Este método irá recalcular a quantidade de cada produto no estoque.",
  ProcessTimeMessage: "Por favor, note que este processo pode levar algum tempo para ser concluído.",
  OpeningBalance: "Saldo inicial",
  ViewJV: "Ver lançamento",
  OpeningStock: "Estoque inicial",
  OpeningBalanceDescription: "O saldo inicial representa o saldo inicial transferido no início de um novo ano financeiro. Esta configuração é feita apenas uma vez no início do ano para garantir o acompanhamento preciso dos registros financeiros.",
  OpeningStockDescription: "A nota fiscal de estoque inicial normalmente inclui tanto a quantidade quanto o custo inicial (ou valor inicial) para itens de inventário no início de um período contábil.",
  Tab: "Aba",
  Products: "Produtos",
 
  CostChanges: "Mudanças de custo",
  Product: "Produto",
  PrintingOptions: "Opções de impressão",
  Language: "Idioma",
  POSOptions: "Opções PDV",
  DineInOptions: "Opções para consumo no local",
  MainCurrency: "Moeda principal*",
  LebaneseLira: "lira libanesa",
  SecondaryCurrency: "Moeda secundária*",
  Balance: "Saldo",
  USdollar: "dólar americano",
  Assets: "Ativos",
Liabilities: "Passivos",
Equity: "Patrimônio líquido",
LiabilitiesEquity: "Passivos e patrimônio líquido",
  Receipt: "Recibo",
  PurchaseReturn: "Devolução de compra",
  InFlow: "Entradas",
  Purchases: "Compras",
  Expenses: "Despesas",
  Payments: "Pagamentos",
  SalesReturn: "Devolução de venda",
  CashVariance: "Diferença em caixa",
  OutFlow: "Saídas",
  CashBalance: "Saldo em caixa",
  SalesDiscounts: "Descontos sobre vendas",
  CostOfGoodsSold: "Custo das mercadorias vendidas",
  PurchaseDiscounts: "Descontos sobre compras",
  GrossProfit: "Lucro bruto",
  OperatingExpenses: "Despesas operacionais",
  NetIncome: "Lucro líquido",
  ProfitAndLoss: "Demonstração do resultado",
  LastModified: "Última modificação",
ModifiedBy: "Modificado por", 
Cost: "Custo",
  Discount: "Desconto",
  Profit: "Lucro",
  In: "ENTRADA",
  Out: "SAÍDA",
  Variance: "Variação",
  Closing: "Fechamento",
  Opening: "Abertura",
  Closed: "Fechado",
  Opened: "Aberto",
  vatGroup: "Grupo de ICMS", // Brazil uses ICMS tax system
  downloadExcelTemplate: "Baixar modelo Excel",
  importExcel: "Importar Excel",
  Simple: "Simples",
  RawMaterial: "Matéria-prima",
  Compound: "Composto",
  Serialized: "Serializado",
  Service: "Serviço",
  Production: "Produção",
  RaiseBy: "Aumentar em",
  PrintName: "Imprimir nome",
  PrintAddress: "Imprimir endereço",
  PrintPhone: "Imprimir telefone",
  PrintDetails: "Imprimir detalhes",
  PrintDiscount: "Imprimir desconto",
  PrintItemPrice: "Imprimir preço do item",
  PrintCategory: "Imprimir categoria",
  PrintingName: "Imprimindo nome",
  PrintingAddress: "Imprimindo endereço",
  PrintingPhone: "Imprimindo telefone",
  ReverseItemOrder: "Inverter ordem dos itens",
  MoneyExchange: "Câmbio monetário",
  UseCustomerPrice: "Usar preço do cliente",
  ShowRateOnInvoice: "Mostrar taxa na nota fiscal",
  ShowPriceInPOSItemsBox: "Mostrar preço na caixa de itens PDV",
  ShowCostInPOSItemsBox: "Mostrar custo na caixa de itens PDV",
  StartSessionAtZero: "Iniciar sessão em zero",
  ShowCostInCart: "Mostrar custo no carrinho",
  NumberOfTabs: "Número de abas"
};

export {
    englishTabs, 
    arabicTabs,
    frenchTabs,
    portugueseTabs,
    spanishTabs,
    brazilianPortugueseTabs,

    englishPages,
    arabicPages,     
    frenchPages,
    portuguesePages,
    spanishPages,
    brazilianPortuguesePages,

    englishForms,
    arabicForms,
    frenchForms,
    spanishForms,
    portugueseForms,     
    brazilianPortugueseForms,

    englishContent,
    arabicContent,
    frenchContent,
    spanishContent,
    portugueseContent,
    brazilianPortugueseContent,


};